var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0128 1.36264C17.7869 1.56044 18.3992 2.14286 18.6072 2.87912C18.9884 4.21978 19 7 19 7C19 7 19 9.79121 18.6187 11.1209C18.4108 11.8571 17.7985 12.4396 17.0244 12.6374C15.6264 13 10 13 10 13C10 13 4.37356 13 2.97561 12.6374C2.20154 12.4396 1.58922 11.8571 1.38126 11.1209C1 9.78022 1 7 1 7C1 7 1 4.21978 1.3697 2.89011C1.57766 2.15385 2.18999 1.57143 2.96406 1.37363C4.362 1.01099 9.98845 1 9.98845 1C9.98845 1 15.6149 1 17.0128 1.36264ZM12.8652 7L8.19769 9.57143V4.42857L12.8652 7Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.939c3652663fc60fed4e843a93f25b49.svg";
export { ForwardRef as ReactComponent };